import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, MenuItem, Select } from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddDPA({
    open,
    onClose,
    setOpen,
}: ModalProps) {

    return (
        <Modal
            className="modal rejectReason_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog take_action_modal">
                <div className="modal-body">

                    {/* Header */}
                    <div className="modal_title">
                        <h2>Create New DPA</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                            aria-label="Close"
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* Form */}
                    <form className="form">
                        <div className="gap_p">

                            {/* DPA Code */}
                            <div className="control_group w_50">
                                <label htmlFor="dpa-code">DPA Code</label>
                                <TextField
                                    placeholder="DPA-XXX"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "dpa-code" }}
                                />
                            </div>

                            {/* Partner Type */}
                            <div className="control_group w_50">
                                <label htmlFor="partner-type">Partner Type</label>
                                <Select fullWidth size="small" defaultValue="Data Processor" inputProps={{ id: "partner-type" }}>
                                    <MenuItem value="Data Processor">Data Processor</MenuItem>
                                    <MenuItem value="Sub-Processor">Sub-Processor</MenuItem>
                                    <MenuItem value="Vendor">Vendor</MenuItem>
                                </Select>
                            </div>

                            {/* Partner Name */}
                            <div className="control_group">
                                <label htmlFor="partner-name">Partner Name</label>
                                <TextField
                                    placeholder="Partner / Vendor name"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "partner-name" }}
                                />
                            </div>

                            {/* Description */}
                            <div className="control_group">
                                <label htmlFor="dpa-description">Description</label>
                                <TextField
                                    placeholder="Brief description of the agreement..."
                                    fullWidth
                                    multiline
                                    rows={3}
                                    hiddenLabel
                                    inputProps={{ id: "dpa-description" }}
                                />
                            </div>

                            {/* Effective Date */}
                            <div className="control_group w_50">
                                <label htmlFor="effective-date">Effective Date</label>
                                <TextField
                                    type="date"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "effective-date" }}
                                />
                            </div>

                            {/* Expiry Date */}
                            <div className="control_group w_50">
                                <label htmlFor="expiry-date">Expiry Date</label>
                                <TextField
                                    type="date"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "expiry-date" }}
                                />
                            </div>

                            {/* Status */}
                            <div className="control_group w_50">
                                <label htmlFor="dpa-status">Status</label>
                                <Select fullWidth size="small" defaultValue="Draft" inputProps={{ id: "dpa-status" }}>
                                    <MenuItem value="Draft">Draft</MenuItem>
                                    <MenuItem value="Active">Active</MenuItem>
                                    <MenuItem value="Expired">Expired</MenuItem>
                                </Select>
                            </div>

                            {/* Document URL */}
                            <div className="control_group">
                                <label htmlFor="document-url">Document URL</label>
                                <TextField
                                    placeholder="https://..."
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "document-url" }}
                                />
                            </div>

                        </div>

                        {/* Footer */}
                        <div className="footer_btn_flex">
                            <Button
                                className="btn btn_grey"
                                variant="outlined"
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>

                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpen(false)}
                            >
                                Create  
                            </Button>
                        </div>
                    </form>


                </div>
            </div>
        </Modal>
    );
}
